import request from "./request";
import { getDeviceFingerprint } from "../utils";
export const getLastTableCount = async ()=>{
    return await request.get("api");
}
export const postRecord = async function (data){
    return await request.post("api",data);
}

export const getHistory = async function (page,limit){
    page = page || 1;
    if(limit){
        return await request.get(`api/${page}`,{
            params: {
                limit,
            }
        });
    }else{
        return await request.get(`api/${page}`);
    }
}

export const deleteRecord = async function (id){
    return await request.delete(`api/${id}`);
}

export const login = async function(phone) {
    const fingerprint = getDeviceFingerprint();
    return await request.post("api/login", { phone, fingerprint });
}